import React from 'react';
import { IconProps } from './types';

const ArrowRight: React.FC<IconProps> = ({
  className,
  size = 32,
  color = '#181B32',
  ignoreColor,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.30689 3.27917C7.705 2.89637 8.33804 2.90879 8.72083 3.30689L17.4145 12.3483L8.69253 20.7214C8.29412 21.1039 7.66109 21.0909 7.27861 20.6925C6.89614 20.2941 6.90906 19.6611 7.30747 19.2786L14.5855 12.2917L7.27917 4.69311C6.89637 4.295 6.90879 3.66196 7.30689 3.27917Z"
      fill={!ignoreColor ? color : undefined}
    />
  </svg>
);

export default ArrowRight;
